import React, { useState } from 'react';
import s from './styles.module.css';

const PhotoUploader = ({ onPhotosChange, photoError, setPhotoError }) => {
    const [photos, setPhotos] = useState([]);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const newPhotos = [...photos, ...files];

        setPhotos(newPhotos);
        onPhotosChange && onPhotosChange(newPhotos);

        if (newPhotos.length > 0) {
            setPhotoError('');
        }
    };


    const handleRemovePhoto = (index) => {
        const updatedPhotos = photos.filter((_, i) => i !== index);
        setPhotos(updatedPhotos);
        onPhotosChange && onPhotosChange(updatedPhotos);
    };

    return (
        <div className={s.photoUploaderMain}>
            <h1>Фото объявления</h1>
            <div className={s.photoUploaderGrid}>
                {photos.map((photo, index) => (
                    <div key={index} className={s.photoPreviewItem}>
                        <img
                            className={s.photoImage}
                            src={URL.createObjectURL(photo)}
                            alt={`Фото ${index + 1}`}
                        />
                        <button
                            type="button"
                            className={s.removePhotoButton}
                            onClick={() => handleRemovePhoto(index)}
                        >
                            ✖
                        </button>
                    </div>
                ))}

                {/* Блок загрузки */}
                <div className={s.photoUploaderContainer}>
                    <label className={s.uploadBoxWrapper}>
                        <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleFileChange}
                            hidden
                        />
                        <img src='/plus.svg' alt='img'/>
                    </label>
                    <p>Нажмите и добавьте изображение</p>
                </div>
            </div>
            {photoError && <p className={s.errorText}>{photoError}</p>}
        </div>
    );
};

export default PhotoUploader;
